import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ProductPage as ProductComponent } from './productpage/Page1'; // Renaming the import to avoid conflict
import { Footer } from '../components/Footer';
import { Page3 } from './productpage/Page3';
import { Page6 } from './homepage/Page6';

// Import Supremelab product images
import glowBooster from '../assets/glow_booster.png';
import hydraglow1 from '../assets/hydraglow1.png';
import hydraglow2 from '../assets/hydraglow2.png';
import hydraglow3 from '../assets/hydraglow3.jpg';
import energyBoost from '../assets/energy-boost.png';
import energyBoost1 from '../assets/serum1.png';
import energyBoost2 from '../assets/serum2.png';
import energyBoost3 from '../assets/serum3.png';
import proAge from '../assets/pro-age.png';
import proAge1 from '../assets/pro-age1.png';
import proAge2 from '../assets/pro-age2.png';
import hyaluMinerals from '../assets/hyalu_minerals.png';
import hyaluMinerals1 from '../assets/hyaluproduct-image.png';
import hyaluMinerals2 from '../assets/hyalu2.jpg';
import hyaluMinerals3 from '../assets/hyaluproduct-4.png';


// Define the product paths as a union type
type ProductPaths =
    | '/product/hydra-glow'
    | '/product/energy-boost'
    | '/product/pro-age-expert'
    | '/product/hyalu-minerals'
    | '/product/larc-cleanser';

const products: Record<ProductPaths, {
    productTitle: string;
    productVolume: string;
    productPrice: string;
    productDescription: string;
    productIngredients: string[];
    productImages: string[];
    productBenefits?: string[];
}> = {
    '/product/hydra-glow': {
        productTitle: 'Bielenda Supremelab Glow Booster Elixir - HYDRA GLOW',
        productVolume: '30ml',
        productPrice: 'RM 383',
        productDescription: `Healthy skin with a glow effect. Modern skincare focuses on lightness and maximum skin comfort. Lightweight cosmetics with strong moisturizing properties help achieve a fresh, radiant, and firm complexion. Key benefits include intense hydration, soothing irritation, restoring natural radiance, and achieving a "plump skin" effect—supple skin, infused with moisture from within. These lightweight, yet rich, hydro-gel formulas refresh and work immediately, without greasiness or the risk of clogging pores. Ideal for normal, combination, dehydrated, dull, or tired skin that needs soothing, hydrating, and brightening.`,
        productIngredients: [
            'Snail Slime Extract (regenerates and nourishes)',
            'CICA (soothes and calms)',
            'Gluconolactone (gentle exfoliation and improves skin texture)',
            'Peptides (firms and supports skin renewal processes)'
        ],
        productImages: [
            glowBooster,
            hydraglow1,
            hydraglow2,
            hydraglow3
        ],
        productBenefits: [
            'Intensely soothes and deeply hydrates',
            'Has anti-inflammatory effect',
            'Restores skin comfort',
            'Does not burden the skin thanks to its light oil-free formula',
            'Provides the Crystal Skin effect restores a healthy glow to the skin'
        ]
    },
    '/product/energy-boost': {
        productTitle: 'Bielenda Supremelab Brightening Serum - ENERGY BOOST',
        productVolume: '15ml',
        productPrice: 'RM 268',
        productDescription: `Effective multi-directional care. Products based on the latest trends combine advanced forms of vitamin C with other powerful ingredients to deliver comprehensive results. By combining antioxidants, brightening, and reducing discoloration and signs of aging, these cosmetics intensely revitalize the skin, restoring its healthy appearance and natural radiance. The formulas have been carefully crafted to perfection – nourishing yet lightweight creams, silky serums that melt into the skin. Effective in the care of all skin types, especially tired, dull skin, skin with discoloration, signs of aging, or excessive oiliness.`,
        productIngredients: [
            'Ascorbyl Tetraisopalmitate (one of two stable forms of vitamin C)',
            'Ethylated Ascorbic Acid (one of two stable forms of vitamin C)',
            'MATRIXYL® SYNTHE 6 peptide',
            'Ceramides (support the hydrolipid barrier)',
            'EGCG and Xanthohumol (modern antioxidants)'
        ],
        productImages: [
            energyBoost,
            energyBoost1,
            energyBoost2,
            energyBoost3
        ],
        productBenefits: [
            'Helps to reduce discoloration',
            'Lightens the skin',
            'Uniforms the coloring',
            'Has a strong antioxidant effect'
        ]
    },
    '/product/pro-age-expert': {
        productTitle: 'Bielenda Supremelab Anti-Wrinkle Serum - PRO AGE EXPERT',
        productVolume: '30ml',
        productPrice: 'RM 278',
        productDescription: `Bielenda PRO Age Expert – cosmetics for mature skin. The PRO Age Expert cosmetics series was created for mature skin showing signs of aging. The anti-wrinkle creams and serums in this line support the skin's natural regenerative processes by providing ingredients that accelerate and improve their effectiveness. This helps maintain skin firmness and elasticity. Initial wrinkles are smoothed, and new ones don't form as quickly as they might without this support. The skin becomes more resistant to the harmful effects of external factors, allowing it to maintain its good appearance and excellent condition. Suitable for daily use, including as a makeup base.`,
        productIngredients: [
            'Nutripeptides® (peptide complex component)',
            'Argireline® peptide (peptide complex component)',
            'Syn®-Coll (peptide complex component)',
            'Tsubaki oil (antioxidant and anti-wrinkle properties)',
            'Chia oil (antioxidant and anti-wrinkle properties)',
            'Squalane (strengthens hydrolipid barrier, retains moisture)'
        ],
        productImages: [
            proAge,
            proAge1,
            proAge2
        ],
        productBenefits: [
            'Smooths initial wrinkles',
            'Prevents new wrinkles from forming',
            'Maintains skin firmness and elasticity',
            'Strengthens skin resistance to external factors'
        ]
    },
    '/product/hyalu-minerals': {
        productTitle: 'Bielenda Supremelab Hydro-Serum - HYALU MINERALS',
        productVolume: '30ml',
        productPrice: 'RM 348',
        productDescription: `A line of formulas as light as water droplets and packed with the power of active ingredients that provide deep hydration, moisturize, strengthen, firm, and smooth the skin. This line is perfect as a lightweight summer skincare routine that can also be used under makeup. We especially recommend it for dehydrated, combination, weakened, dull, tired, and problematic skin. The main active ingredient is three types of hyaluronic acid with different molecular weights working together to penetrate deep layers, moisturize, and create a protective hydrofilm.`,
        productIngredients: [
            'Hyaluronic acid 2-10 kDa (ultra-low molecular weight - penetrates deep, improves elasticity and firmness, anti-wrinkle properties)',
            'Hyaluronic acid 50-100 kDa (medium molecular weight - anti-wrinkle and moisturizing, works superficially)',
            'Hyaluronic acid 1000-1500 kDa (large molecular weight - creates protective hydrofilm, prevents moisture loss, smooths wrinkles)'
        ],
        productImages: [
            hyaluMinerals,
            hyaluMinerals1,
            hyaluMinerals2,
            hyaluMinerals3
        ],
        productBenefits: [
            'Strongly hydrates',
            'Strengthens the skin',
            'Smooths',
            'Supports regeneration processes',
            'Has anti-wrinkle properties, reduces the signs of aging',
            'Improves the overall condition and appearance of the skin'
        ]
    },
    '/product/larc-cleanser': {
        productTitle: 'L\'Arc Gentle Foaming Cleanser',
        productVolume: 'coming soon RM ???',
        productPrice: '',
        productDescription: `L'Arc Gentle Foaming Cleanser is a premium skincare solution designed for professional results in the comfort of your home. This gentle cleanser effectively removes impurities while maintaining the skin's natural moisture balance.`,
        productIngredients: [
            'Gentle cleansing agents',
            'Moisturizing ingredients',
            'Skin-soothing extracts'
        ],
        productImages: [
            hyaluMinerals1 // Using a placeholder image, you can replace this with the actual L'A cleanser image
        ],
        productBenefits: [
            'Gently cleanses without stripping natural oils',
            'Maintains skin\'s moisture balance',
            'Suitable for all skin types',
            'Leaves skin feeling fresh and clean'
        ]
    },
};

const ProductPage: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    // Cast location.pathname to the ProductPaths type
    const currentProduct = products[location.pathname as ProductPaths] || products['/product/hydra-glow'];
    const handleBackClick = () => {

        // Check if there is history to go back to
        if (window.history.length > 1) {
            // If there is history, navigate back
            window.history.back();
        } else {
            // If there is no history, navigate to the /skin page
            navigate('/skin');
        }
    };

    return (
        <>
            <ProductComponent {...currentProduct} productPath={location.pathname as ProductPaths} onBackClick={handleBackClick} /> {/* Rendering the ProductPage with the props */}
            <Page6 />
            <Page3 />
            <Footer />
        </>
    );
};

export default ProductPage;
